module.exports = __webpack_public_path__ + "img/icon_3.293f45d2.svg";